import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import { Skeleton } from '@mui/lab';

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: '#fff',
    padding: '14px 16px',
    height: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: '#0076FF',
    color: 'white',
    height: '56px',
    padding: '0 16px',
    marginBottom: '8px',
    borderRadius: '4px 4px 0 0',
  },
  headerCell: {
    flex: 1,
    marginRight: '16px',
    '&:last-child': {
      marginRight: 0,
    },
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    height: '52px',
    padding: '0 16px',
    borderBottom: '1px solid #f0f0f0',
    '&:nth-of-type(even)': {
      backgroundColor: '#f9f9f9',
    },
  },
  cell: {
    flex: 1,
    marginRight: '16px',
    '&:last-child': {
      marginRight: 0,
    },
  },
  actionCell: {
    flex: 0.8,
    display: 'flex',
    justifyContent: 'center',
  },
  skeleton: {
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    animation: '$skeleton-loading 1.5s infinite ease-in-out',
  },
  '@keyframes skeleton-loading': {
    '0%': {
      backgroundColor: '#f0f0f0',
    },
    '50%': {
      backgroundColor: '#e0e0e0',
    },
    '100%': {
      backgroundColor: '#f0f0f0',
    },
  },
}));

const TableSkeletonLoader = ({ rows = 5, columns = 4 }) => {
  const classes = useStyles();

  const renderHeader = () => (
    <div className={classes.header}>
      {Array.from({ length: columns }).map((_, index) => (
        <div key={index} className={classes.headerCell}>
          <Skeleton 
            variant="text" 
            width="80%" 
            height="20px"
            animation="wave"
            className={classes.skeleton}
          />
        </div>
      ))}
    </div>
  );

  const renderRows = () => (
    <>
      {Array.from({ length: rows }).map((_, rowIndex) => (
        <div key={rowIndex} className={classes.row}>
          {Array.from({ length: columns - 1 }).map((_, colIndex) => (
            <div key={colIndex} className={classes.cell}>
              <Skeleton 
                variant="text" 
                width={`${60 + Math.random() * 40}%`} 
                height="16px"
                animation="wave"
                className={classes.skeleton}
              />
            </div>
          ))}
          <div className={classes.actionCell}>
            <Skeleton 
              variant="circle" 
              width="32px" 
              height="32px"
              animation="wave"
              className={classes.skeleton}
            />
          </div>
        </div>
      ))}
    </>
  );

  return (
    <div className={classes.container}>
      {renderHeader()}
      {renderRows()}
    </div>
  );
};

export default TableSkeletonLoader;
